import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { DefaultHeaderComponent } from './default-header/default-header.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { FormErrorComponent } from './form-error/form-error.component';
import { CrudBuilderComponent } from './crudbuilder/crud-builder.component';
import { OvercardComponent } from './overcard/overcard.component';
import { NotificationModalComponent } from './notification-modal/notification-modal.component';
import { NgxGaugeModule } from 'ngx-gauge';
import { WizardAccountComponent } from './wizard-account/wizard-account.component';
import { WizardCrudbuilderComponent } from './wizard-crudbuilder/wizard-crudbuilder.component';
import { NoArrowDirective } from '@core/no-arrow.directive';
// Added by Joseph - 04/16/20
import { ChartsModule } from 'ng2-charts';
import { GoalsComponent } from './goals/goals.component';
import { WeeklyCostComponent } from './weekly-cost/weekly-cost.component';
import { ImprovedCostComponent } from './improved-cost/improved-cost.component';
import { MonthlyCostComponent } from './monthly-cost/monthly-cost.component';
import { YearlyCostComponent } from './yearly-cost/yearly-cost.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { DutchCurrencyFieldComponent } from './dutch-currency-field/dutch-currency-field.component';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { ModalContactFormComponent } from './modal-contact-form/modal-contact-form.component';
import { SavingWidgetComponent } from './saving-widget/saving-widget.component';
import { ViaWizardComponentComponent } from './via-wizard-component/via-wizard-component.component';
import { MaxMortgageComponent } from './max-mortgage/max-mortgage.component';

import { Ionic4DatepickerModule } from '@logisticinfotech/ionic4-datepicker';
import { CostPerMonthCircleDiagramComponent } from '@core/components/cost-per-month-circle-diagram/cost-per-month-circle-diagram.component';
import { DiagramsModule } from '@core/components/diagrams/diagrams.module';
import { ReadbuilderComponent } from '@core/components/readbuilder/readbuilder.component';
import { ProjectComponentComponent } from './timpaan-component/timpaan-component.component';

@NgModule({
  declarations   : [
    DefaultHeaderComponent,
    FormErrorComponent,
    CrudBuilderComponent,
    OvercardComponent,
    NotificationModalComponent,
    WizardAccountComponent,
    WizardCrudbuilderComponent,
    NoArrowDirective,
    GoalsComponent,
    WeeklyCostComponent,
    ImprovedCostComponent,
    MonthlyCostComponent,
    YearlyCostComponent,
    CostPerMonthCircleDiagramComponent,
    ReadbuilderComponent,
    DutchCurrencyFieldComponent,
    DatePickerComponent,
    ModalContactFormComponent,
    SavingWidgetComponent,
    ViaWizardComponentComponent,
    MaxMortgageComponent,
    ProjectComponentComponent
  ],
  imports        : [
    CommonModule,
    IonicModule,
    FormsModule,
    NgxGaugeModule,
    ChartsModule,
    Ionic4DatepickerModule,

    NgCircleProgressModule.forRoot({
      // set defaults here
      radius           : 100,
      outerStrokeWidth : 16,
      innerStrokeWidth : 8,
      outerStrokeColor : "#78C000",
      innerStrokeColor : "#C7E596",
      animationDuration: 300
    }),

    DiagramsModule,

  ],
  providers: [CurrencyPipe],
  entryComponents: [
    NotificationModalComponent
  ],
  exports        : [
    DefaultHeaderComponent,
    FormErrorComponent,
    CrudBuilderComponent,
    OvercardComponent,
    NotificationModalComponent,
    WizardAccountComponent,
    WizardCrudbuilderComponent,
    GoalsComponent,
    WeeklyCostComponent,
    ImprovedCostComponent,
    MonthlyCostComponent,
    YearlyCostComponent,
    CostPerMonthCircleDiagramComponent,
    ReadbuilderComponent,
    DutchCurrencyFieldComponent,
    DatePickerComponent,
    ModalContactFormComponent,
    SavingWidgetComponent,
    ViaWizardComponentComponent,
    MaxMortgageComponent,
    ProjectComponentComponent
  ]
})
export class ComponentsModule {
}
